import { IMenuPage, IUndecoratedMenuPage } from './menu';

export type IUndecoratedNav = IUndecoratedMenuPage;

export type IDecoratedNav = IMenuPage;
